import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TeacherProvider } from 'src/app/providers/teacher/teacher.provider';
import { Course } from 'src/app/models/course';
import { Teacher } from 'src/app/models/teacher';
import { LessonSong } from 'src/app/models/lesson-song';
import { Collection } from 'src/app/models/collection';
import { Song } from 'src/app/models/song';
import { Resources } from 'src/app/models/resources';
import { ResourcesProvider } from 'src/app/providers/resources/resources.provider';
import {AudioProvider} from '../../providers/audio/audio.provider';
import { MenuController, PopoverController } from '@ionic/angular'
import { BowlingSongCssService } from './bowling-song-css.service'
import { WindowService } from '../../services/window.service'
import { TeacherStore } from 'src/app/stores/teacher.store';
import { ResourceStore } from 'src/app/stores/resources.store';
import { Subject, map, takeUntil } from 'rxjs';
import { MenuPopoverComponent } from 'src/app/components/menu-popover/menu-popover.component';
import { Lesson } from 'src/app/models/lesson';
import { environment } from 'src/environments/environment';

export class PageItem {
  name: string
  action?: () => void
}
@Component({
  selector: 'app-bowling',
  templateUrl: './bowling.page.html',
  styleUrls: ['./bowling.page.scss'],
})
export class BowlingPage implements OnInit {

  ngUnsubscribeTeacher = new Subject();
  ngUnsubscribeResources = new Subject();

  teacher: Teacher // = this.teacherProvider.teacher
  resources: Resources // = this.resourcesProvider.resources
  courseUuid: string
  lessonUuid: string
  get course(): Course { return this.teacher.findCourse(this.courseUuid) || Course.defaults() }
  get collection(): Collection { return this.resources.findCollection(this.course.collectionUuid) || Collection.defaults() }
  weekItems: number[];
  selectedPage: string = 'Page 1';
  lessonByPage: Lesson[];

  constructor(private route: ActivatedRoute,
    private router: Router,
    private teacherProvider: TeacherProvider,
    private resourcesProvider: ResourcesProvider,
    public audioProvider: AudioProvider,
    private menuCtrl: MenuController,
    public bowlingSongCssService: BowlingSongCssService,
    private windowService: WindowService,
    private teacherStore: TeacherStore,
    private resourceStore: ResourceStore,
    private popoverCtrl: PopoverController,) { 

      this.courseUuid = this.route.snapshot.paramMap.get('course')
      this.lessonUuid = this.route.snapshot.paramMap.get('lesson')

    }

  ngOnInit() {
    this.windowService.width$.subscribe((value: number) => this.bowlingSongCssService.width = value)

    this.teacher = this.teacherProvider.teacher;
    this.teacherStore.state$
        .pipe(takeUntil(this.ngUnsubscribeTeacher))
        .subscribe(() => {
          this.teacher = this.teacherProvider.teacher;
        });

    this.resources = this.resourceStore.getResources();
    this.resourceStore.state$
        .pipe(takeUntil(this.ngUnsubscribeResources))
        .subscribe(() => {
          this.resources = this.resourceStore.getResources();
          if(this.teacher.findCourse(this.courseUuid)?.lessons?.length > 0){
            this.onLessonPageChange()
          }
        })
  }

  ngOnDestroy(){
    this.ngUnsubscribeTeacher.next(true);
    this.ngUnsubscribeTeacher.complete();
    this.ngUnsubscribeResources.next(true);
    this.ngUnsubscribeResources.complete();
  }

  get songs(): Song[] {
    let songs = this.collection.songs
    songs = this.filter(songs)
    songs = this.sort(songs)
    return songs
  }

  // private filterSongs(songs: Song[]): Song[] {
  //   // 309 -Song Selection Slider > If name of song = "Tonal Patterns" or "Rhythm Patterns" do not show in song list
  //   // See Teacher Edition collections for examples

  //   const selectedCollectionName = this.selectedCollection.name
  //   let allowRPTP: boolean = selectedCollectionName.includes('Rhythm Kids') || selectedCollectionName.includes('MTIS')

  //   songs = songs.filter((song: Song) => {
  //     if (allowRPTP) {
  //       return !song.isInstrumental && !song.isSilentTrack
  //     }
  //     return !song.isTonalPatterns && !song.isRhythmPatterns && !song.isInstrumental && !song.isSilentTrack
  //   })



  filter(songs: Song[]): Song[] {
    const selectedCollectionName = this.collection.name

    // const allowedRPTPPatterns = ['Rhythm Kids', 'bilingue-italiano', 'bilingue-espanol']
    const allowedRPTPPatterns = environment.rptpExclusionCollectionPatterns
    
    let allowRPTP: boolean = allowedRPTPPatterns.some((pattern: string) => {
      return selectedCollectionName.toLowerCase().includes(pattern.toLowerCase())
    })

    let filteredSongs = songs.filter((song: Song) => {
      return (
        !song.name.toLowerCase().includes("(inst.)") &&
        !song.name.toLowerCase().includes("(inst)") && 
        !song.name.toLowerCase().includes("(instrumental)") && 
        !song.name.toLowerCase().includes("silent track")
      )
    })

    if (!allowRPTP) {
      filteredSongs = filteredSongs.filter((song: Song) => {
        return (
          !song.isTonalPatterns &&
          !song.isRhythmPatterns
        )
      })
    }

    return filteredSongs
  }

  sort(songs: Song[]): Song[] {
    return songs.sort((a: Song, b: Song) => {
      if (a.isHelloSong) { return -1 }
      if (b.isHelloSong) { return 1 }
      if (a.isGoodbyeSong) { return -1 }
      if (b.isGoodbyeSong) { return 1 }
      return a.name < b.name ? -1 : 1
    })
  }

  songInfoSong: Song

  showSongInfo(song: Song) {
    this.songInfoSong = song
    this.menuCtrl.open('song-details-bowling-menu')
  }

  doneSongInfo() {
    this.menuCtrl.close()
  }

  trackbySongUuid(index: number, song: Song): string {
    return song.uuid
  }

  scrollLeft: number = 0
  onScroll(event: Event) {
    this.scrollLeft = event.target['scrollLeft']
  }

  gotoWeek(lessonIndex: number) {
    if (lessonIndex < this.course.displayableLessons.length) {
      const lesson = this.course.displayableLessons[lessonIndex]
      this.router.navigate(['lesson', this.course.uuid, lesson.uuid, 'bowling'])
    }
  }

  presentPagePopover(event) {
    const pageItem  = [{name: 'Page 1'}, {name: 'Page 2'}, {name: 'Page 3'}]
    MenuPopoverComponent.present(this.popoverCtrl, 'lesson-plans-popover', event,
      pageItem.map((page: PageItem) => {
        return {
          name: page.name, action: () => {
            this.selectedPage = page.name
            this.onLessonPageChange()
          }
        }
      }, 240)
    )
  }
  
  onLessonPageChange(){
    if(this.course && this.course?.displayableLessons?.length == 0) return;
    switch (this.selectedPage) {
      case 'Page 1':{
        this.weekItems = Array(10).fill(1).map((n, i) => n + i);
        let currentPageLessons: Lesson[] = [];
        for (let index = 0; index < 10; index++) {
          if (this.course.displayableLessons[index]){
            currentPageLessons.push(this.course.displayableLessons[index])
          }
        }
        this.lessonByPage = currentPageLessons;
        break;
      }
      case 'Page 2':{
        this.weekItems = Array(10).fill(11).map((n, i) => n + i);
        let currentPageLessons: Lesson[] = [];
        for (let index = 10; index < 20; index++) {
          if(this.course.displayableLessons[index]){
            currentPageLessons.push(this.course.displayableLessons[index])
          }
        }
        this.lessonByPage = currentPageLessons;
        break;
      }
      case 'Page 3':{
        this.weekItems = Array(10).fill(21).map((n, i) => n + i);
        let currentPageLessons: Lesson[] = [];
        for (let index = 20; index < 30; index++) {
         if(this.course.displayableLessons[index]){
          currentPageLessons.push(this.course.displayableLessons[index])
          }
        }
        this.lessonByPage = currentPageLessons;
        break;
      }
      default:
        break;
    }
  }
}
